"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../data/constants");
var abstractComponent_1 = __importDefault(require("./abstractComponent"));
var odometer_1 = __importDefault(require("odometer"));
var BenefitsCountUp = /** @class */ (function (_super) {
    __extends(BenefitsCountUp, _super);
    function BenefitsCountUp(selector) {
        var _this = _super.call(this) || this;
        _this.selector = selector;
        _this.benefitsList = document.querySelectorAll(_this.selector);
        if (_this.benefitsList.length < 1)
            return _this;
        _this.countUpEnd = document.querySelectorAll("[".concat(constants_1.DATA_NUMBER_COUNT_UP_END, "]"));
        _this.benefitsOdometer = document.querySelectorAll("[".concat(constants_1.DATA_ODOMETER, "]"));
        _this.benefitsList.forEach(function (element) {
            _this.benefitsIsInViewport(element);
            window.addEventListener('scroll', function () {
                _this.benefitsIsInViewport(element);
            });
        });
        return _this;
    }
    /**
     * Initialize Odometer, odometer.js (JS and CSS library)
     * @param element - CountUpEnd Number of Benefits Item
     * @public
     * Docs: https://github.hubspot.com/odometer/docs/welcome/
     */
    BenefitsCountUp.prototype.initializeOdometer = function (element) {
        var odometer = new odometer_1.default({
            el: element,
            value: 0,
            duration: 3000,
            format: '( ddd),dd',
            theme: 'minimal'
        });
        odometer.update(element.getAttribute('data-number-count-up-end'));
    };
    /**
     * getBenefitsItem of Benefits List
     * @param elem - Benefits List
     * @private
     */
    BenefitsCountUp.prototype.getBenefitsItems = function (elem) {
        var _this = this;
        elem.querySelectorAll("[".concat(constants_1.DATA_NUMBER_COUNT_UP_END, "]")).forEach(function (element) {
            _this.initializeOdometer(element);
        });
    };
    /**
     * Check if benefits mask element is in the viewport
     * @param elem - Benefits List
     * @private
     */
    BenefitsCountUp.prototype.benefitsIsInViewport = function (elem) {
        var rect = elem.getBoundingClientRect();
        if (rect.top <= ((window.innerHeight || document.documentElement.clientHeight)) && rect.bottom >= 50) {
            this.getBenefitsItems(elem);
        }
    };
    return BenefitsCountUp;
}(abstractComponent_1.default));
exports.default = BenefitsCountUp;
